import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Action } from '../../../../types/Action';
import NumericInputField from '../../../turn-portfolio/TurnList/PortfolioListFilters/Shared/NumericinputField';

type MinMaxDropdownOptionProps = {
  minPossibleValue?: number;
  maxPossibleValue?: number;
  min: number;
  max: number;
  valueChangeAction: (filter: MinMaxFilter) => Action;
  fontColor?: string;
  isPricePrefix?: boolean;
  initialMin?: number;
  initialMax?: number;
};

export type MinMaxFilter = {
  min: number;
  max: number;
};

const MinMaxDropdownOption: FC<MinMaxDropdownOptionProps> = (props) => {
  const dispatch = useDispatch();
  const [error, setError] = useState(false);

  const handleInput = useCallback(
    (value: number, isMin: boolean) => {
      const validValue =
        isNaN(value) || value === undefined ? (isMin ? props.initialMin : props.initialMax) : value;
      const otherValue = isMin ? props.max : props.min;
      if (
        validValue === -1 ||
        otherValue === -1 ||
        (isMin ? validValue <= otherValue : validValue >= otherValue)
      ) {
        setError(false);
        dispatch(
          props.valueChangeAction({
            min: isMin ? validValue : props.min,
            max: isMin ? props.max : validValue,
          }),
        );
      } else {
        setError(true);
      }
    },
    [dispatch, props.max, props.min, props.valueChangeAction],
  );
  return (
    <Wrapper data-testid='min-max-dropdown-option'>
      <NumericInputFieldContainer>
        <NumericInputField
          value={props.min}
          minPossibleValue={props.minPossibleValue}
          maxPossibleValue={props.maxPossibleValue}
          handleInput={(value) => handleInput(value, true)}
          debounceTime={800}
          label='Min'
          fontColor={props.fontColor ? props.fontColor : 'default'}
          isPricePrefix={props.isPricePrefix}
        />
        <NumericInputField
          value={props.max}
          minPossibleValue={props.minPossibleValue}
          maxPossibleValue={props.maxPossibleValue}
          handleInput={(value) => handleInput(value, false)}
          debounceTime={800}
          label='Max'
          fontColor={props.fontColor ? props.fontColor : 'default'}
          isPricePrefix={props.isPricePrefix}
        />
      </NumericInputFieldContainer>
      {error && <ErrorMessage>Invalid Range</ErrorMessage>}
    </Wrapper>
  );
};

export default MinMaxDropdownOption;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NumericInputFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 140px;
  margin: 20px;
  justify-content: space-between;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  & input {
    border-radius: 0px;
    background-color: transparent;
    border: none;
    border-bottom: 2px solid #ccc;
    width: 100%;
    color: #fff;
    padding: 0px 4px;
    text-align: center;
  }
`;

const ErrorMessage = styled.span`
  color: #ff0000;
  font-size: 16px;
  font-weight: 600;
  margin-top: 8px;
  margin-right: 0px;
  align-self: center;
`;
